import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AssignmentDto, AssignmentSubtableDataDto, AssignmentType } from '../../shared/generated/backend';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-assignment-detail',
  imports: [TranslateModule, CommonModule],
  templateUrl: './assignment-detail.component.html',
  styleUrl: './assignment-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssignmentDetailComponent {
  readonly assignmentId = input.required<number>();

  readonly type = input.required<AssignmentType>();

  readonly data = input.required<
    | (AssignmentDto & {
        subtableData?: AssignmentSubtableDataDto;
      })
    | undefined
  >();

  readonly subtableData = input.required<AssignmentSubtableDataDto | undefined>();
}
